export const RoleEnum = Object.freeze({
    user: "user",
    admin: "administrator",
    verify: "verify",
    sale: "sale"
})